import basicGroupVue from './basicGroup.vue';
export default {
  components: {
    basicGroupVue: basicGroupVue
  }
};